import amount from './amount';
import friendlyShortDate from './friendly_short_date';
import friendlyDateTime from './friendly_date_time';
import number from './number';
import timestamp from './timestamp';
import phonenumber from './phonenumber';
import formatdate from './formatdate';
import formatduration from './formatduration';
import capitalizeFirstLetter from './capitalizeFirstLetter';
import convertToNth from './converttonth';

export default {
  install(Vue) {
    Vue.filter('number', number);
    Vue.filter('amount', amount);
    Vue.filter('friendly_short_date', friendlyShortDate);
    Vue.filter('friendly_date_time', friendlyDateTime);
    Vue.filter('timestamp', timestamp);
    Vue.filter('phonenumber', phonenumber);
    Vue.filter('formatdate', formatdate);
    Vue.filter('formatduration', formatduration);
    Vue.filter('capitalizeFirstLetter', capitalizeFirstLetter);
    Vue.filter('convertToNth', convertToNth);
  },
};
